export class Modelo {
    id: number;
    tipoDocumento: number;
    nome: string;
    conteudo: string;
    statusAtivo: boolean;
    necessarioAssinatura: boolean;
    padrao: boolean;
    dataCadastro: Date
    orientacaoPagina: 'RETRATO'|'PAISAGEM'
}